import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import History from "@/pages/History";
import Pastor from "@/pages/Pastor";
import Ministries from "@/pages/Ministries";
import BookPastor from "@/pages/BookPastor";
import CalendarPage from "@/pages/CalendarPage";
import MediaLibrary from "@/pages/MediaLibrary";
import ServicesArchive from "@/pages/ServicesArchive";
import Music from "@/pages/Music";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import ECampus from "@/pages/ECampus";
import Members from "@/pages/Members";
import NewMemberInfo from "@/pages/NewMemberInfo";
import MemberResources from "@/pages/MemberResources";
import ChurchSchedule from "@/pages/ChurchSchedule";
import LeadersDirectory from "@/pages/LeadersDirectory";
import NewMemberForms from "@/pages/NewMemberForms";
import MinistryMedia from "@/pages/MinistryMedia";
import Announcements from "@/pages/Announcements";
import LiveStream from "@/pages/LiveStream";
import PrayerRequest from "@/pages/PrayerRequest";
import FamilyLifeConference from "@/pages/FamilyLifeConference";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/history" element={<History />} />
            <Route path="/pastor" element={<Pastor />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/book-pastor" element={<BookPastor />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/media-library" element={<MediaLibrary />} />
            <Route path="/services-archive" element={<ServicesArchive />} />
            <Route path="/live-stream" element={<LiveStream />} />
            <Route path="/prayer" element={<PrayerRequest />} />
            <Route path="/family-life-conference" element={<FamilyLifeConference />} />
            <Route path="/flc" element={<Navigate to="/family-life-conference" replace />} />
            <Route path="/music" element={<Music />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donate/success" element={<DonateSuccess />} />
            <Route path="/e-campus" element={<ECampus />} />

            {/* Leadership Portal (login required) */}
            <Route path="/members" element={<ProtectedRoute><Members /></ProtectedRoute>} />
            <Route path="/members/new" element={<NewMemberInfo />} />
            <Route path="/members/resources" element={<ProtectedRoute><MemberResources /></ProtectedRoute>} />
            <Route path="/members/schedule" element={<ProtectedRoute><ChurchSchedule /></ProtectedRoute>} />
            <Route path="/members/directory" element={<ProtectedRoute><LeadersDirectory /></ProtectedRoute>} />
            <Route path="/members/forms" element={<ProtectedRoute><NewMemberForms /></ProtectedRoute>} />
            <Route path="/members/announcements" element={<ProtectedRoute><Announcements /></ProtectedRoute>} />

            {/* Ministry media (login required) */}
            <Route path="/ministry-media" element={<ProtectedRoute><MinistryMedia /></ProtectedRoute>} />

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Admin only */}
            <Route path="/admin" element={<ProtectedRoute adminOnly={true}><Admin /></ProtectedRoute>} />

            {/* Mega-menu category redirects — these labels are menu groupings, not real pages */}
            <Route path="/connect" element={<Navigate to="/calendar" replace />} />
            <Route path="/media" element={<Navigate to="/media-library" replace />} />

            {/* Catch-all — send unknown URLs home instead of blank screen */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#170B10", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
